<template>
    <div class="absolute -z-10"
         style="background-image: radial-gradient(rgba(255, 255, 255, 0.05), transparent 70%);"></div>
</template>
